var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6587 9.92542L13.3504 15.0115C13.1726 15.1615 13.0059 15.2226 12.8643 15.2226C12.7226 15.2226 12.5318 15.1609 12.4035 15.0368L7.07019 9.92542C6.80364 9.67265 6.79497 9.22543 7.05019 8.98376C7.30366 8.71641 7.72741 8.70771 7.99212 8.9638L12.8643 13.6337L17.7364 8.9671C18.0003 8.71102 18.4248 8.71971 18.6784 8.98706C18.9336 9.22543 18.9253 9.67265 18.6587 9.92542Z",
    fill: "#B3C0C3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.36438,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#B3C0C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareArrowDown);
export default __webpack_public_path__ + "static/media/share-arrow-down.193503797061d9827116e83a206a32f0.svg";
export { ForwardRef as ReactComponent };